import { render, staticRenderFns } from "./social-media.vue?vue&type=template&id=6155b75e&scoped=true"
import script from "./social-media.vue?vue&type=script&lang=js"
export * from "./social-media.vue?vue&type=script&lang=js"
import style0 from "./social-media.vue?vue&type=style&index=0&id=6155b75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6155b75e",
  null
  
)

export default component.exports